var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdministratorIconColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 6,
    fill: "none",
    viewBox: "0 0 5 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1c2238",
    d: "M4.874 1.475a.236.236 0 0 0-.118-.205L2.545.029a.215.215 0 0 0-.215 0L.12 1.269A.236.236 0 0 0 0 1.476C-.03 3.23.675 5.302 2.351 5.982c.06.024.112.024.173 0 1.676-.68 2.382-2.752 2.35-4.507zm-2.66 3.926C1.357 4.922.915 4.041.688 3.234h1.526v2.167zm0-2.635H.576a6.808 6.808 0 0 1-.127-1.15l1.765-.99v2.14zM2.661 5.4V3.234h1.526c-.227.806-.669 1.688-1.526 2.167zm1.638-2.635H2.661V.626l1.765.99c-.004.211-.026.642-.127 1.15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministratorIconColor);
export default __webpack_public_path__ + "static/media/administrator_icon_color.708c52bc33ede5db0bb86ed67ae61cc0.svg";
export { ForwardRef as ReactComponent };